import { SetStateAction, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Layout from "../../components/Layout/Layout";
import ApplicationVersionList from "../../components/ApplicationVersionList/ApplicationVersionList";
import { CalendarEvent, PersonFill } from "react-bootstrap-icons";
import { getApplication } from "../../api/applicationApi";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import { LAYOUT_TYPE } from "../../constants";
import { getDateAsIsoString } from "../../helpers/textHelper";

export default function Application() {
  const [application, setApplication] = useState<any>();
  const [error, setError] = useState("");
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getApplication(
      Number(params.applicationId),
      (responseData: SetStateAction<any>) => {
        setApplication(responseData);
      },
      (errorText: React.SetStateAction<string>) => {
        setError(errorText);
      }
    );
  }, [params.applicationId]);

  if (error) {
    return <ErrorMessage text={error} className="m-5" />;
  }

  return (
    <>
      {application ? (
        <Layout
          type={LAYOUT_TYPE.INNER_PAGE}
          title={application.name}
          backButtonTitle="Applications"
          subtitle={application.packageName}
          infoFields={[
            {
              icon: <PersonFill />,
              title: application.createdBy,
            },
            {
              icon: <CalendarEvent />,
              title: getDateAsIsoString(application.createdOn),
            },
          ]}
          buttons={[
            {
              title: "Edit",
              variant: "outline-primary",
              action: () => {
                navigate("/application/" + params.applicationId + "/edit");
              },
            },
            {
              title: "Create New Version",
              variant: "primary",
              action: () => {
                navigate(
                  "/application/" + params.applicationId + "/version/create"
                );
              },
            },
          ]}
        >
          {params.applicationId && (
            <ApplicationVersionList
              applicationId={Number(params.applicationId)}
            />
          )}
        </Layout>
      ) : (
        <Layout type={LAYOUT_TYPE.INNER_PAGE_LOADING} />
      )}
    </>
  );
}
